import {TimerReducerType} from '../actions/types/timer.action.types';
import {UPDATE_TIMER} from '../actions/timer.actions';

export interface TimerReducerState {
    timeElapsed: number;
}

export const preloadedState = {
    timeElapsed: 0,
};

export const timerReducer = (state = preloadedState, action: TimerReducerType): TimerReducerState => {
    switch (action.type) {
        case UPDATE_TIMER:
            return {...state, timeElapsed: action.payload};
        default:
            return state;
    }
};
